const BING_SEARCH_PRIVACY_LINK = 'https://go.microsoft.com/fwlink/?LinkId=521839';

export default BING_SEARCH_PRIVACY_LINK;
